import GlobalContainer from '@ui/container/global-container';

const EmptyCastAndCrewBlur = () => {
  return (
    <GlobalContainer
      className="position-absolute left-0 right-0 opacity-15"
      css={{
        'background-color': 'var(--local-bttn-prim-default-bg)',
        width: '482px',
        height: '236px',
        margin: '0 auto',
        'border-radius': '482px',
        filter: 'blur(200px)',
      }}
    />
  );
};

export default EmptyCastAndCrewBlur;
